/*
 * toggle stufff
 * by ole fjarestad
 */

// action menu toggle (the three vertical dots, providing various actions)
/*$( document ).on('click', '.actions__toggle', function(event) {
	$(this).closest('.actions').toggleClass('actions--open');
	event.preventDefault();
});
$( document ).on('click', function(event) {
	if ( $(event.target).closest('.actions').length == 0 ) {
		$('.actions').removeClass('actions--open');
	}
});
$( document ).on('keyup', function(event) { // on tabthrough
	if ( event.which == 9 ) { // 9 = tab
		setTimeout( function() { // hack for getting correct currently focused element (and not the previous one)
			$closestActions = $( document.activeElement ).closest('.actions');
			if ( $closestActions.length ) {
				$closestActions.addClass('actions--open');
			} else {
				$( '.actions' ).removeClass('actions--open');
			}
		}, 0);
	}
});*/


/**
 * [ole] what is this? simen, did you write this?
 */
$( document ).on('click', '.swBtn', function(event) {

	var $this = $( this );

	if ( $this.parent().hasClass( 'isActive' ) ) {

		if ( $('#swResponse').hasClass( 'success' ) ) {
			setTimeout(function() {
			    $this.parent().toggleClass( 'isActive' );
				$this.parent().prev('.toggle').toggleClass( 'isActive' );
				//$this.toggleClass('success');
			}, 1000);
		}
	}
});


/**
 * prevent default
 * .js--preventDefault is a helper class that can be applied to any element to prevent default behaviour
 * by ole fjarestad
 */
$( document ).on('click', '.js--preventDefault', function( event ) {
	event.preventDefault();
});





/**
 * clicking [data-toggle]="value" toggles .isActive on [data-toggled-by="value"]
 * generic functionality that can be used to show/hide (or affect in any number of ways) elements
 * by ole fjarestad
 */
jQuery(document).on('click', '[data-toggle]', function (event)
{

	var toggle = jQuery(this).data('toggle');
	var $triggers = jQuery( '[data-toggle="' + toggle + '"]' );
	var $targets = jQuery('[data-toggled-by="' + toggle + '"]');


	// extra functionality for certain elements
	if ( toggle == 'js--siteMenu' )
	{
		jQuery( '#js--topMenu' ).toggleClass( 'isActive' );
		jQuery( '#js--wrap' ).toggleClass( 'isActive' );
	}


	$triggers.toggleClass( 'isActive' );
	$targets.toggleClass( 'isActive' );


	// set focus to first input field in $targets
	if ( $targets.hasClass('isActive') )
	{
		$targets.find('input').eq(0).focus();
		console.log( $targets.find('input').eq(0) );
	}

	// only preventDefault if $target(s) exists
	if ($targets.length > 0) {

		event.preventDefault();

	}

});


//////////////////
// WEBPACK FOOTER
// ./src/assets/js/partials/toggle.js
// module id = ./src/assets/js/partials/toggle.js
// module chunks = main